/**
 * @module buttonHeader
 */

module.exports = function( button ) {
    const mobileHeader = document.querySelector( '.mobile-header' );

    const observer = new IntersectionObserver( ( entries ) => {
        const entry = entries[ 0 ];

        if ( ! entry.isIntersecting && entry.boundingClientRect.top < 0 ) {
            mobileHeader.classList.add( 'header-with-button', 'border-dark' );
        } else {
            mobileHeader.classList.remove( 'header-with-button', 'border-dark' );
        }
    }, {
        threshold: 0,
    } );

    observer.observe( button );
};
